/* eslint-disable */
import { StyleSheet } from "react-native"
import { ApplicationStyles ,Fonts} from "../../Themes/"

export default StyleSheet.create({
  ...ApplicationStyles.screen,
  container : {
    flex : 1
  },
  fillParent: {
    backgroundColor: 'transparent',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0
  },
  overLay:
  {
    position: 'absolute', top: 40, left: 15,
    right: 15, bottom: 20,
    borderWidth: 2, borderColor: 'black',
    borderRadius: 25, backgroundColor: 'white',
    padding: 10
  },
  boldText : {
    fontFamily: Fonts.style.font.bold
  },
  cellbg1: {
    backgroundColor: "rgba(222, 238, 249, 255)"
  },
  cellbg2: {
    backgroundColor: "rgba(237, 244, 213, 255)"
  },
  cellbg3: {
    backgroundColor: "rgba(249, 216, 200, 255)"
  },
  cellbg4: {
    backgroundColor: "rgba(251, 236, 209, 255)"
  },
  containerGridLeft: {
    justifyContent: "space-around",
    alignItems: "center",
    flex: 1,
    backgroundColor: "#ffbb00"
  },
  containerGridMiddle: {
    justifyContent: "space-around",
    alignItems: "center",
    flex: 1,
    backgroundColor: "#00a1f1"
  },
  containerGridRight: {
    justifyContent: "space-around",
    alignItems: "center",
    flex: 1,
    backgroundColor: "#7cbb00"
  },
  smallIcon: {
    height: 10,
    position: 'absolute',
    bottom: 10,
    right: 10,
    backgroundColor: 'green',
  },
  footerContainer: {
    backgroundColor: "#ffffff",
    height: 44,
    display: 'flex',
    flexDirection: 'row'
  },
  footerWrapper: {
    flex: 1,
    flexDirection: 'row',
    height  : 44,
    alignItems: 'center',
    justifyContent: 'space-around',
    borderColor: 'grey'
  },
  tagStyle: {
    position: 'absolute',
    height: 50 ,

  },
  tabTextStyle: {
    color: 'black',
    fontSize: 14,
    lineHeight: 18,
  },
  userName: {
    color: 'rgba(80,83,114,1)',
    fontWeight: 'bold' // web patch 
  },
  userNameFooter: {
    color: 'rgba(80,83,114,1)',
    lineHeight: 18,
    fontSize: 13,
    fontFamily: Fonts.style.font.bold,
  }
})
